import React from "react";
import { Link } from "react-router";
import classnames from "classnames";

import "./Button.css";

export const Button = ({ type, href, children, external = false }) => {
  const classes = classnames("btn", type ? "btn-" + type : null);
  const inner = href.startsWith("http") || external
    ? <a className={classes} href={href}>{children}</a>
    : <Link className={classes} to={href}>{children}</Link>;
  return inner;
};

export const TextButton = ({ href, children, external = false }) => {
  const inner = href.startsWith("http") || external
    ? <a className="txt-btn" href={href}>{children}<TextButtonIcon /></a>
    : <Link className="txt-btn" to={href}>{children}<TextButtonIcon /></Link>;
  return inner;
};

export const ButtonGroup = ({ children }) => (
  <div className="btn-group">{children}</div>
);

const TextButtonIcon = () => (
  <svg width="6px" height="10px">
    <g><polyline points="0,0 5,5 0,10" /></g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Button.js